module.exports = __webpack_public_path__ + "static/apple-icon-144x144-9e019b8682cf9977995206f868751275.png";